<template>
  <v-app-bar
    :color="'blue-darken-3'"
    elevation="0"
    app
    density="compact"
    theme="dark"
  >
    <v-toolbar-title class="flex-grow-0 flex-shrink-0"></v-toolbar-title>

    <component
      :is="canOpenAiChat ? 'router-link' : 'span'"
      v-if="$store.getters.authenticated"
      v-bind="canOpenAiChat ? { to: getAccountRoute('/ai') } : {}"
      class="nav-logo-link mr-3 d-inline-flex"
      :title="canOpenAiChat ? 'Webwalker AI' : undefined"
    >
      <v-avatar
        size="30"
        color="blue-darken-3"
        class="nav-logo-avatar"
      >
        <v-img
          src="../../assets/logo-white-30.png"
          max-width="30"
          max-height="30"
          contain
        ></v-img>
      </v-avatar>
    </component>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/"
      icon="mdi-view-dashboard"
    >Dashboard</base-main-nav-btn>

    <base-main-nav-btn
      v-if="account"
      :to="getAccountRoute('/workflows')"
    >
      <v-icon class="mr-1" size="small">mdi-cogs</v-icon>
      Workflows
    </base-main-nav-btn>

    <base-main-nav-btn
      v-if="account && !truncateMenuL2"
      :to="getAccountRoute('/linkedin-conversations')"
      icon="mdi-forum"
    >
      <v-icon class="mr-1" size="small">mdi-forum</v-icon>
      Conversations
    </base-main-nav-btn>

    <v-menu
      :theme="dropdownTheme"
      v-if="account"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-account-box-multiple"
          v-bind="props"
        >
          Contacts
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-account-box-multiple</v-icon>
          Contacts
          <base-info-icon
            label="Manage and organize your contact data."
          />
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          :to="getAccountRoute('/contacts')"
        >
          <v-list-item-title>Contacts</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-contacts</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          :to="getAccountRoute('/companies')"
        >
          <v-list-item-title>Companies</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-briefcase</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          :to="getAccountRoute('/contact-lists')"
        >
          <v-list-item-title>Lists</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-table-account</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          :to="getAccountRoute('/contacts-import')"
        >
          <v-list-item-title>Import</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-cloud-upload</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <base-main-nav-btn
      v-if="account && !truncateMenu"
      :to="getAccountRoute('/task-boards')"
      icon="mdi-bullseye-arrow"
    >Tasks</base-main-nav-btn>

    <base-main-nav-btn
      v-if="account && !truncateMenu"
      :to="getAccountRoute('/notes')"
      icon="mdi-note"
    >Notes</base-main-nav-btn>

    <base-main-nav-btn
      v-if="account && !truncateMenu"
      :to="getAccountRoute('/tags')"
      icon="mdi-tag"
    >Tags</base-main-nav-btn>

    <v-menu
      :theme="dropdownTheme"
      v-if="account"
      v-model="menuLinkedin"
      location="bottom start"
      :close-on-content-click="false"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-linkedin</v-icon>
          LinkedIn
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-linkedin</v-icon>
          LinkedIn
          <base-info-icon
            label="Manage your LinkedIn accounts and the related data."
          />
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          :to="getAccountRoute('/linkedin')"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Accounts</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-box-multiple</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          :to="getAccountRoute('/linkedin-conversations')"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Conversations</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-forum</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          :to="getAccountRoute('/linkedin-searches')"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Searches</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-search</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          :to="getAccountRoute('/linkedin-connections')"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Connections</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-multiple</v-icon>
          </template>
        </v-list-item>

        <v-list-group>
          <template #activator="{ props }">
            <v-list-item v-bind="props">
              <v-list-item-title>Invitations</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            :to="getAccountRoute('/linkedin-invitations-received')"
            @click="closeLinkedinMenu"
            class="pl-6"
          >
            <v-list-item-title>Received</v-list-item-title>
            <template #append>
              <v-icon size="small">mdi-account-multiple-plus</v-icon>
            </template>
          </v-list-item>

          <v-list-item
            :to="getAccountRoute('/linkedin-invitations-sent')"
            @click="closeLinkedinMenu"
            class="pl-6"
          >
            <v-list-item-title>Sent</v-list-item-title>
            <template #append>
              <v-icon size="small">mdi-account-multiple-plus-outline</v-icon>
            </template>
          </v-list-item>
        </v-list-group>

        <v-list-item
          :to="getAccountRoute('/linkedin-suggestions')"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Suggestions</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-question</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          :to="getAccountRoute('/linkedin-views')"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Views</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-target-account</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          :to="getAccountRoute('/linkedin-groups')"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Groups</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-group</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-group>
          <template #activator="{ props }">
            <v-list-item v-bind="props">
              <v-list-item-title>LinkedIn Company Page</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            :to="getAccountRoute('/linkedin-company-posts')"
            @click="closeLinkedinMenu"
            class="pl-6"
          >
            <v-list-item-title>Posts</v-list-item-title>
            <template #append>
              <v-icon size="small">mdi-note-text</v-icon>
            </template>
          </v-list-item>

          <v-list-item
            :to="getAccountRoute('/linkedin-company-invitations-sent')"
            @click="closeLinkedinMenu"
            class="pl-6"
          >
            <v-list-item-title>Invitations Sent</v-list-item-title>
            <template #append>
              <v-icon size="small">mdi-briefcase-plus</v-icon>
            </template>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="account && !truncateMenu"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-wrench</v-icon>
          Integrations
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-wrench</v-icon>
          Integrations
          <base-info-icon
            v-if="!$store.getters.canUseApiIntegrations"
            label="These features are available on Pro and Max plans (or legacy Regular/Premium)."
            to="/billing"
          />
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          :to="getAccountRoute('/integrations')"
          :disabled="!$store.getters.canUseApiIntegrations"
        >
          <v-list-item-title>API Integrations</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-api</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          :to="getAccountRoute('/webhooks')"
          :disabled="!$store.getters.canUseApiIntegrations"
        >
          <v-list-item-title>Webhooks</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-webhook</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="account && !truncateMenuL1"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-chart-box"
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-chart-box</v-icon>
          Reports
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-chart-box</v-icon>
          Reports
          <base-info-icon
            label="Track and measure performance of your account."
          />
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          :to="getAccountRoute('/overview')"
        >
          <v-list-item-title>Overview</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-calendar</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          :to="getAccountRoute('/reports')"
        >
          <v-list-item-title>Charts</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-chart-areaspline</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="account && truncateMenu"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-table"
          v-bind="props"
        >
          <span v-if="!truncateMenuL3">More</span>
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-item
          :to="getAccountRoute('/task-boards')"
        >
          <v-list-item-title>Tasks</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-bullseye-arrow</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          :to="getAccountRoute('/notes')"
        >
          <v-list-item-title>Notes</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-note</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          :to="getAccountRoute('/tags')"
        >
          <v-list-item-title>Tags</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-tag</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-chart-box</v-icon>
          Reports
          <base-info-icon
            label="Track and measure performance of your account."
          />
        </v-list-subheader>

        <v-list-item
          :to="getAccountRoute('/overview')"
        >
          <v-list-item-title>Overview</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-calendar</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          :to="getAccountRoute('/reports')"
        >
          <v-list-item-title>Charts</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-chart-areaspline</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-wrench</v-icon>
          Integrations
          <base-info-icon
            v-if="!$store.getters.canUseApiIntegrations"
            label="These features are available on Pro and Max plans (or legacy Regular/Premium)."
            to="/billing"
          />
        </v-list-subheader>

        <v-list-item
          :to="getAccountRoute('/integrations')"
          :disabled="!$store.getters.canUseApiIntegrations"
        >
          <v-list-item-title>API Integrations</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-api</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          :to="getAccountRoute('/webhooks')"
          :disabled="!$store.getters.canUseApiIntegrations"
        >
          <v-list-item-title>Webhooks</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-webhook</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-spacer></v-spacer>

    <div
      class="d-flex align-center ga-1"
    >
    <v-menu
      :theme="dropdownTheme"
        v-if="$store.getters.authenticated && $route.name !== 'Global Search'"
        :close-on-content-click="false"
        location="bottom end"
        class="search-menu"
    >
      <template #activator="{ props }">
        <v-btn
            icon
            size="small"
            v-bind="props"
        >
          <v-icon size="small">mdi-magnify</v-icon>
        </v-btn>
      </template>

      <v-card
          class="pa-2 d-flex align-center ga-2"
          min-width="280"
      >
        <base-view-header-search
            v-model="globalSearchQuery"
            label="Global Search"
            class="flex-grow-1"
            style="min-width: 180px"
            @keyup.enter="redirectToGlobalSearchResults"
        ></base-view-header-search>
        <base-sidebar-btn
            @click="redirectToGlobalSearchResults"
            label="Search"
            btn-class="primary"
        ></base-sidebar-btn>
      </v-card>
    </v-menu>

    <v-tooltip location="bottom">
      <template #activator="{ props }">
        <v-btn
          href="https://docs.webwalker.io/wiki/"
          target="_blank"
          icon
          size="small"
          class="mx-1"
          v-bind="props"
        >
          <v-icon size="small">mdi-book-open-outline</v-icon>
        </v-btn>
      </template>
      <span>Knowledge Base</span>
    </v-tooltip>

    <main-nav-notifications
      v-if="$store.getters.authenticated"
    ></main-nav-notifications>

    <v-btn
      v-if="$store.getters.authenticated"
      to="/settings"
      icon
      size="small"
    >
      <v-icon size="small">mdi-account-circle</v-icon>
    </v-btn>

    <v-tooltip v-if="$store.getters.authenticated && $store.state.isDarkMode" location="bottom">
      <template #activator="{ props }">
        <v-btn v-bind="props" size="small" icon @click="$store.dispatch('switchDarkMode', false)">
          <v-icon size="small" color="yellow">mdi-moon-waxing-crescent</v-icon>
        </v-btn>
      </template>
      <span>Disable dark mode</span>
    </v-tooltip>
    <v-tooltip v-else-if="$store.getters.authenticated" location="bottom">
      <template #activator="{ props }">
        <v-btn v-bind="props" size="small" icon @click="$store.dispatch('switchDarkMode', true)">
          <v-icon size="small" color="yellow">mdi-white-balance-sunny</v-icon>
        </v-btn>
      </template>
      <span>Enable dark mode</span>
    </v-tooltip>
    </div>

    <v-divider
      v-if="$store.getters.authenticated"
      v-show="!this.isAuthView"
      vertical
      class="ml-2 mr-4"
    ></v-divider>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated"
      location="bottom start"
    >
      <template #activator="{ props }">
        <v-btn
          variant="text"
          class="main-nav-btn mx-1"
          size="small"
          v-bind="props"
        >
          <v-icon class="mr-3" size="small">mdi-domain</v-icon>
          {{ ((account) ? account.name : 'Select Account') }}
          <v-icon>mdi-menu-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-subheader style="max-height: 30px;">{{ this.$store.state.user.name }} {{ this.$store.state.user.email }}</v-list-subheader>
        <v-list-subheader
          v-if="account"
        >{{ account.name }}</v-list-subheader>

        <v-divider></v-divider>

        <v-list-subheader>Account Management</v-list-subheader>

        <v-list-item
          :to="getAccountRoute('/account')"
          density="compact"
        >
          <v-list-item-title>Configuration</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-cog</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          v-if="$store.getters.isOwner"
          :to="getAccountRoute('/users')"
          density="compact"
        >
          <v-list-item-title>Manage Users</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-group</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          v-if="$store.getters.isOwner"
          :to="getAccountRoute('/billing')"
          density="compact"
        >
          <v-list-item-title>Manage Billing</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-credit-card-outline</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          to="/accounts"
        >
          <v-list-item-title>My Accounts</v-list-item-title>
          <template #append>
            <v-icon>mdi-domain</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          v-for="(acc, index) in this.$store.state.accounts"
          :key="index"
          :disabled="acc.id == account.id"
          @click="switchAccountRoute(acc)"
        >
          <v-list-item-title>{{ acc.name }}</v-list-item-title>
          <template #append>
            <v-icon>mdi-location-enter</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-divider
      v-if="$store.getters.authenticated"
      v-show="!this.isAuthView"
      vertical
    ></v-divider>

    <v-btn
      class="main-nav-btn mx-2"
      size="small"
      variant="text"
      v-if="!this.$store.getters.authenticated"
      :to="{name: 'Login'}"
    >
      <v-icon class="mr-1" size="small">mdi-login</v-icon>
      Login
    </v-btn>
    <v-btn
      class="main-nav-btn mx-2"
      size="small"
      variant="text"
      v-if="!this.$store.getters.authenticated"
      :to="{name: 'Sign Up'}"
    >
      Sign Up
    </v-btn>
    <v-btn
      class="mx-2"
      icon
      size="small"
      v-if="this.$store.getters.authenticated"
      @click="logoutConfirmation = true"
    >
      <v-icon size="small">mdi-logout</v-icon>
    </v-btn>
    <base-dialog-confirmation
      v-model="logoutConfirmation"
      prompt="Do you really want to logout?"
      confirm-text="Logout"
      confirm-color="red"
      @confirm="logout"
      @cancel="logoutConfirmation = false"
    ></base-dialog-confirmation>
  </v-app-bar>
</template>

<script>
import MainNavNotifications from '@/components/layout/MainNavNotifications.vue';

export default {
  name: 'MainNavV2',

  components: {
    MainNavNotifications,
  },

  data() {
    return {
      logoutConfirmation: false,
      menuLinkedin: false,
      truncateMenu: false,
      truncateMenuL1: false,
      truncateMenuL2: false,
      truncateMenuL3: false,
      globalSearchQuery: '',
    };
  },

  computed: {
    accountId: function () {
      var params = this.$route.params;
      if (params && params['accountId']) return params['accountId'];
      if (this.$store.state.account) return this.$store.state.account.id;
      if (this.$store.state.accounts && this.$store.state.accounts.length) {
        return this.$store.state.accounts[0].id;
      }
      return null;
    },
    account: function () {
      if (!this.$store.state.accounts || !this.accountId) return false;
      return this.$store.state.accounts.find(x => x.id == this.accountId);
    },
    isAuthView() {
      // Check if on auth pages (login, sign up, password reset, etc)
      if (this.$route && this.$route.meta) {
        return this.$route.meta.public;
      }
      return false;
    },
    dropdownTheme() {
      return this.$store.state.isDarkMode ? 'dark' : 'light';
    },
    canOpenAiChat() {
      return !!this.account;
    },
  },

  created() {
    this.resizeScreen();
    window.addEventListener("resize", this.resizeScreen);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.resizeScreen);
  },

  methods: {

    getAccountRoute: function (route) {
      if (!this.accountId) return route;
      return '/account/' + this.accountId + route;
    },

    switchAccountRoute: function(account) {
      // Get the current route and change the account id
      var params = { ...this.$route.params };
      params['accountId'] = account.id;

      // Store as the last selected account
      this.$store.commit('setAccount', account);

      // Reload the page with updated params
      this.$router.push({
        name: this.$route.name,
        params: params,
      }).then(() => {
        window.location.reload();
      }).catch(()=>{
        window.location.reload();
      });
    },

    logout: function () {
      this.$emit('logout');
    },

    resizeScreen: function () {
      this.truncateMenu = window.innerWidth < 1600;
      this.truncateMenuL1 = window.innerWidth < 1300;
      this.truncateMenuL2 = window.innerWidth < 1200;
      this.truncateMenuL3 = window.innerWidth < 1050;
    },

    redirectToGlobalSearchResults: function () {
      this.$router.push({
        name: 'Global Search',
        params: {
          accountId: this.accountId,
        },
        query: {
          q: this.globalSearchQuery,
        },
      });
    },

    closeLinkedinMenu: function () {
      this.menuLinkedin = false;
    },
  },
};
</script>
